// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ef-6";
export var emphasizeQuantity = "_ef-3";
export var flatBottomCorners = "_ef-5";
export var productImage = "_ef-0";
export var quantityContainer = "_ef-2";
export var tooltip = "_ef-1";
export var wrapAndEllipsesOverflow = "_ef-4";